<div class="inputTitle" *ngIf="label">
    <span>{{ label }}</span>
</div>

<div [class.has-errors]="errors?.length" class="moneyForm" [hidden]="!isEditable">
    <div fxLayout="row" class="webMoney">
        <mat-form-field appearance="outline" (focusout)="onFocusOut($event)">
            <input matInput type="number" [name]="formFieldName" [ngModel]="amount" (ngModelChange)="setAmount($event)"
                [disabled]="disabled" [min]="minValue" [max]="maxValue" [maxlength]="maxlength" [minlength]="minlength"
                oninput="if (value.length > maxLength) value = value.slice(0, maxLength);"
                (keypress)="default($event)" />
        </mat-form-field>
        <div class="selectNew" fxFlex="58px">
            <logzy-currency-search [updatedCurrency]="currencyCode" [disabled]="curdisabled"
                (newCurrency)="getUpdatedvalue($event)"></logzy-currency-search>
        </div>
    </div>
</div>

<div class="viewLable" [hidden]="isEditable">
    <span>
        {{ getDisplay() }}
    </span>
</div>

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{ item }}</li>
</ul>